import React from 'react'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import { ThemeProvider } from '@/components/theme/ThemeProvider'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

createInertiaApp({
  resolve: (name: string) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, { default: React.ComponentType }>
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    const root = createRoot(el)
    root.render(
      <ThemeProvider>
        <App {...props} />
      </ThemeProvider>
    )
  },
})
